import { createAction, props } from '@ngrx/store';
import { UIActions } from './actions';

export const sidebarToggle = createAction(UIActions.UI_SIDEBAR_TOOGLE);

export const sidebarSetState = createAction(
  UIActions.UI_SIDEBAR_SET_STATE,
  props<{ payload: string }>()
);

export const currentTop = createAction(
  UIActions.UI_SET_CURRENT_SCROLL_TOP,
  props<{ payload: number }>()
);
export const hideSidebar = createAction(UIActions.UI_HIDE_SIDEBAR);
export const showSidebar = createAction(UIActions.UI_SHOW_SIDEBAR);
